import {atom} from "recoil";

const authEmpty = JSON.stringify({
    user: null,
    token: null
})

const authAtom = atom({
    key: "auth",
    // get initial state from local storage to enable user to stay logged in
    default: JSON.parse(localStorage.getItem("admin") !== "undefined" ? localStorage.getItem("admin") : authEmpty)
});

export {authAtom};
